import { render, staticRenderFns } from "./PostFormEdit.vue?vue&type=template&id=db6169a6&scoped=true&"
import script from "./PostFormEdit.vue?vue&type=script&lang=js&"
export * from "./PostFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./PostFormEdit.vue?vue&type=style&index=0&id=db6169a6&scoped=true&lang=css&"
import style1 from "./PostFormEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6169a6",
  null
  
)

export default component.exports